import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify'

import Login from './screens/Login';
import UserList from './screens/UserList';
import AddRole from './screens/addRole';
import Customers from './screens/Customers';
import Roles from './screens/Roles';
import SideBar from './components/SideBar';
import Container from './components/Container';
import TaskList from './screens/Task';
import Pincode from './screens/Pincode';
import TaskIdList from './screens/TaskId';
import TaskList1 from './screens/Task1';
import TaskById from './screens/taskById';
import Settings from './screens/Settings';
import ResignedUsers from './screens/ResignedUser';
import UnAssigned from './screens/UnAssignedTask';
import TransferredTask from './screens/TransferredTask';
import UserByID from './screens/UserById';
import Dashboard from './screens/Dashboard';
import TaskCount from './screens/TaskCount';
import RoleByID from './screens/RoleById';
// import Allocation from './screens/Allocation';
// import BankTask from './screens/BankTaskList';
import BankTask from './screens/BankTask';
import FieldExecutiveTasksScreen from './screens/FieldExecutiveTasks';
import FieldCount from './screens/FieldCountList';
import FieldHourTask from './screens/FieldHourTask';
import CompletedTask from './screens/CompletedTask';
import FinalHourTask from './screens/FinalHourTask';
import './assests/styles.css';
import './App.css';
import './assests/scripts'
import FinalisationTask from './screens/FinalisationTask';
import InProgressTask from './screens/InProgressTask';
import Video from './screens/Video';
import 'bootstrap/dist/css/bootstrap.min.css';
import Onemoth from './screens/oneMonthTask';
import JobDoneTask from './screens/JobDoneTask';
import ProcessList from './screens/ProcessList';
import DailyCollection from './screens/DailyCollection';
import MonthlyCollection from './screens/MonthlyCollection';
import AssignProcess from './screens/AssignProcess';
import DailyMIS from './screens/DailyMis';
import MonthlyMis from './screens/MonthlyMis';
import DelhiPage from './screens/DelhiPage';
import HaryanaPage from './screens/HaryanaPage';
import UPPage from './screens/UpPage';
import TataPage from './screens/TataPage';
import HdfcCardPage from './screens/HdfcCardPage';
import HDFCRetailPage from './screens/HdfcRetailPage';
import IDFCPage from './screens/IdfcPage';
import KotakPage from './screens/KotakPage';
import TatAnalysis from './screens/TatAnalysis';
import VerificationProcessList from './screens/VerificationProcessList';
import AssignVerificationProcess from './screens/AssignVerificationProcess';
import TatAnalysisReport from './screens/TatAnalysisReport';
import HdfcCardUPPage from './screens/HdfcCardUPPage';
import HdfcRetailUPPage from './screens/hdfcRetailUPPage';
import ProspectForm from './screens/ProspectForm';
import SalaryManagementWithMasters from './screens/SalaryManagementWithMasters';
import CompanyMaster from './screens/CompanyMaster';
import EmployeeMaster from './screens/EmployeeMaster';
import SupervisorMaster from './screens/SupervisorMaster';
import BillingMaster from './screens/BillingMaster';
import ProvisionalBilling from './screens/ProvisionalBilling';
import Distribution from './screens/Distribution';
import CollectionMis from './screens/CollectionMis';
import ConsolidatedMis from './screens/ConsolidatedMis';
import PriceMaster from './screens/PriceMaster';
import ReimbursementMaster from './screens/ReimbursementMaster';
import CaseMaster from './screens/CaseMaster';
import PenaltyMaster from './screens/PenaltyMaster';
import ConveyanceMaster from './screens/ConveyanceMaster';
import VerificationReport from './screens/VerificationReport';
import PayablesMIS from './screens/PayablesMIS';

function App() {
  return (
    <Router>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="*" element={<DefaultContainer />} />
      </Routes>
    </Router>
  );
}

const DefaultContainer = () => {
  return (
    <Container>
      <SideBar />
      <div className='mx-auto py-10 px-6 bg-gray-100 overflow-x-auto w-4/5'>
        <Routes>
          <Route path="/users" element={<UserList />} exact />
          <Route path="/customers" element={<Customers />} exact />
          <Route path="/roles" element={<Roles />} exact />
          <Route path='/roles/add' element={<AddRole />} exact />
          <Route path='/roles/update/:id' element={<RoleByID />} />
          <Route path="/tasks" element={<TaskList />} exact />
          {/* <Route path="/allocation" element={<Allocation />} exact /> */}
          <Route path='/finalisation' element={<FinalisationTask />} exact />
          <Route path='/completed' element={<CompletedTask />} exact />
          <Route path='/jobdone' element={<JobDoneTask />} exact />
          <Route path='/inprogress' element={<InProgressTask />} exact />
          <Route path="/collection" element={<TaskList1 />} exact />
          <Route path="/tasksid" element={<TaskIdList />} exact />
          <Route path="/pincodes" element={<Pincode />} exact />
          <Route path="/tasks/:id" element={<TaskById />} exact />
          <Route path='/settings' element={<Settings />} exact />
          <Route path='/unassigned' element={<UnAssigned />} exact />
          <Route path='/transferred' element={<TransferredTask />} exact />
          <Route path='/users/:id' element={<UserByID />} exact />
          <Route path='/video-call' element={ <Video />} exact />
          {/* <Route path='/dashboard' element={ <Dashboard />} exact />
          <Route path='/taskcount' element={ <TaskCount />} exact /> */}
          <Route path='/dashboard12' element={ <Dashboard />} exact />
          <Route path='/taskcount12' element={ <TaskCount />} exact />
          <Route path='/field-task' element={ <FieldExecutiveTasksScreen />} exact />
          <Route path='/resigned' element={ <ResignedUsers />} exact />
          <Route path='/banktasks' element={ <BankTask />} exact />
          {/* <Route path='/fieldcount' element={ <FieldCount />} exact />
          <Route path='/fe-task' element={ <FieldHourTask />} exact />
          <Route path='/finalise-count' element={ <FinalHourTask />} exact />
          <Route path='/one-month' element={ <Onemoth />} exact /> */}
          <Route path='/fieldcount12' element={ <FieldCount />} exact />
          <Route path='/fe-task12' element={ <FieldHourTask />} exact />
          <Route path='/finalise-count12' element={ <FinalHourTask />} exact />
          <Route path='/one-month12' element={ <Onemoth />} exact />
          <Route path='/process' element={ <ProcessList />} exact />
          <Route path='/dailyCollection' element={ <DailyCollection />} exact />
          <Route path='/monthlyCollection' element={ <MonthlyCollection />} exact />
          <Route path='/assignProcess' element={ <AssignProcess />} exact />
          <Route path='/dailyMis' element={ <DailyMIS />} exact />
          <Route path='/monthlyMis' element={ <MonthlyMis />} exact />
          <Route path='/drive/nbfc/delhi' element={<DelhiPage />} exact />
          <Route path='/drive/nbfc/haryana' element={<HaryanaPage />} exact />
          <Route path='/drive/nbfc/up' element={<UPPage />} exact />
          <Route path='/drive/nbfc/tata' element={<TataPage />} exact />
          <Route path='/drive/hdfc/card' element={<HdfcCardPage />} exact />
          <Route path='/drive/hdfc/retail' element={<HDFCRetailPage />} exact />
          <Route path='/drive/idfc' element={<IDFCPage />} exact />
          <Route path='/drive/kotak' element={<KotakPage />} exact />
          <Route path='/tatAnalysis' element={<TatAnalysis />} exact />
          <Route path='/verification-process' element={<VerificationProcessList />} exact />
          <Route path='/assignVerificationProcess' element={<AssignVerificationProcess />} exact />
          <Route path='/tat-analysis-report' element={<TatAnalysisReport />} exact />
          <Route path="/drive/hdfc/card-up" element={<HdfcCardUPPage />} />
          <Route path="/drive/hdfc/retail-up" element={<HdfcRetailUPPage />} />
          <Route path="/earlyprospect" element={<ProspectForm />} exact />
          <Route path="/salary-management" element={<SalaryManagementWithMasters />} exact />
          <Route path="/company-master" element={<CompanyMaster />} exact />
          <Route path="/employee-master" element={<EmployeeMaster />} exact />
          <Route path="/supervisor-master" element={<SupervisorMaster />} exact />
          <Route path="/billing-master" element={<BillingMaster />} exact />
          <Route path="/provisional-billing" element={<ProvisionalBilling />} exact />
          <Route path="/distribution" element={<Distribution />} exact />
          <Route path="/collection-mis" element={<CollectionMis />} exact />
          <Route path="/consolidated-mis" element={<ConsolidatedMis />} exact />
          <Route path="/verification-master/price-master" element={<PriceMaster />} exact />
          <Route path="/verification-master/reimbursement-master" element={<ReimbursementMaster />} exact />
          <Route path="/verification-master/case-master" element={<CaseMaster />} exact />
          <Route path="/verification-master/penalty-master" element={<PenaltyMaster />} exact />
          <Route path="/verification-master/conveyance-master" element={<ConveyanceMaster />} exact />
          <Route path="/verification-master/verification-report" element={<VerificationReport />} exact />
          <Route path="/verification-master/mis" element={<PayablesMIS />} exact />
        </Routes>
      </div>
    </Container>
  )
}

export default App;
